module.exports = __webpack_public_path__ + "static/media/ict.419c0b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ict.jpg
// module id = 5813
// module chunks = 0